import { useSelector } from 'react-redux'
import { RootState } from '../redux'

export default function useLifts() {
  return useSelector((state: RootState) => state.lifts.lifts)
}
